import { FC } from 'react'
import { OverviewItemContainer } from './OverviewCard.styles'
import { OverviewItemProps } from './OverviewCard.types'
import { OverviewListItem } from './OverviewListItem'

const OverviewCard: FC<OverviewItemProps> = ({
    id,
    featureIcon,
    featureTitle,
    monitoringStatsTitle,
    monitoringStatsSubtitle,
    monitoringStatsIcon,
    monitoringStatsCount,
    isActive,
    hasConnectionError,
    onClick,
    isLoading,
    alertCount,
    alertTooltipText,
}) => {
    return (
        <OverviewItemContainer data-testid={`overview-card-${id}`}>
            <OverviewListItem
                id={`${id}-feature`}
                data-testid={`${id}-overview-feature`}
                title={featureTitle}
                isActive={isActive}
                hasConnectionError={hasConnectionError}
                icon={featureIcon}
                onClick={onClick}
                isLoading={isLoading}
            />
            <OverviewListItem
                id={`${id}-monitoring-stats`}
                data-testid={`${id}-overview-monitoring-stats`}
                title={monitoringStatsTitle}
                subtitle={monitoringStatsSubtitle}
                monitoringStatsCount={monitoringStatsCount}
                isActive={isActive}
                icon={monitoringStatsIcon}
                showIconBackground={false}
                showConnectionStatus={false}
                alertCount={alertCount}
                alertTooltipText={alertTooltipText}
            />
        </OverviewItemContainer>
    )
}

export default OverviewCard
